module.exports = __webpack_public_path__ + "static/media/mvicon_128.be715537.png";